import {PrType} from '../../interfaces/process-reports/pr-type';
import {PrFormControl} from '../../interfaces/process-reports/pr-form-control';
import {PrFormControlFactory} from './pr-form-control-factory';
import {PrInputGroup} from '../../interfaces/process-reports/pr-input-group';
import {PrInputGroupFactory} from './pr-input-group-factory';

export class PrTypeFactory {

  /**
   *
   * @param prType
   */
  public static fromObject(prType: any): PrType {
    return new class implements PrType {
      created: string = prType.created;
      forCustomers: boolean = prType.for_customers;
      forEmployees: boolean = prType.for_employees;
      id: number = prType.id;
      modified: string = prType.modified;
      name: string = prType.name;
      color: string = prType.color;
      isDeactivated: boolean = prType.is_deactivated;
      shortName: string = prType.short_name;
      isDefault: boolean = prType.is_default;
      isToRead: boolean = prType.is_to_read;
      isToConfirm: boolean = prType.is_to_confirm;
      viewMode: 'collapsed' | 'expanded' = prType.view_mode;
      formValuesViewMode: 'collapsed' | 'expanded' = prType.form_values_view_mode;
      formValuesPosition: 'below' | 'above' = prType.form_values_position;
      forServiceFacilities: boolean = prType.for_service_facilities;
      prFormControls: PrFormControl[] =
        PrFormControlFactory.fromArray(prType.pr_form_controls);
      numberOfUnread: number = prType.number_of_unread;
      prInputGroups: PrInputGroup[] = PrInputGroupFactory.fromArray(prType.pr_input_groups);
      setToUnreadAllowed: boolean = prType.set_to_unread_allowed;
      isInCarePlan: boolean = prType.is_in_care_plan;
      isTextRequired: boolean = prType.is_text_required;
      textLabel: string = prType.text_label;
      withoutText: boolean = prType.without_text;
      serviceFacilityId: number = prType.service_facility_id;
    };
  }

  /**
   *
   * @param prTypes
   */
  public static fromArray(prTypes: any[]): PrType[] {
    return prTypes.map(_prType => this.fromObject(_prType));
  }
}
